import Head from "next/head";
import MagicRollTablesPage from "../../../../src/tables/s14/MagicRollTables.tsx";

export default function MagicRollTablesRoute({ tables }) {
  return (
    <>
      <Head>
        <title>TFT Set 14 Magic Roll Tables</title>
      </Head>
      <MagicRollTablesPage tables={tables} />
    </>
  );
}

export async function getStaticProps() {
  const tablesResp = await fetch(
    `https://ap.tft.tools/static/s14/hacked_egg.json`,
  );
  const tables = await tablesResp.json();

  return {
    props: {
      tables,
    },
    revalidate: 3600,
  };
}
